export default function LogoFlexport() {
  return (
    <svg
      width="124"
      height="28"
      viewBox="0 0 124 28"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M123.659 18.5791H119.015V23.1706H123.659V18.5791Z" fill="currentColor" />
      <path
        d="M14.5176 17.8557V0.94809H20.0919V17.1547C20.0919 18.2963 20.3459 18.5728 21.5259 18.5728H22.0053L22.6618 23.0529C22.2398 23.1086 20.5108 23.2292 19.4711 23.2292C16.4033 23.2292 14.5176 22.1697 14.5176 17.8557Z"
        fill="currentColor"
      />
      <path
        d="M57.2229 7.52809L61.5588 7.19483L61.9818 8.47211C62.8545 7.66177 64.3743 6.85754 67.6413 6.85754C73.2745 6.85754 74.5674 10.7836 74.5674 15.1543C74.5674 19.5544 73.1336 23.4247 67.3033 23.4247C64.7123 23.4247 63.5019 22.8403 62.7961 22.1991V27.7701H57.2229V7.52809ZM68.908 15.3833C68.908 13.5175 68.57 11.8745 66.1491 11.8745C63.5581 11.8745 62.7982 13.1832 62.7982 15.3833C62.7982 17.5833 63.3602 18.7795 66.1491 18.7795C68.5137 18.7745 68.908 17.2429 68.908 15.3833Z"
        fill="currentColor"
      />
      <path
        d="M94.459 7.52824L98.7948 7.19499L99.3577 8.86224C100.061 7.91516 102.005 7.10788 104.313 7.02481V12.3315C100.597 12.3598 100.034 13.4568 100.034 15.6285V23.1747H94.459V7.52824Z"
        fill="currentColor"
      />
      <path
        d="M105.869 7.03382H108.736L109.638 3.79252L113.946 2.87381V7.03382H117.466V12.3374H113.946V16.9371C113.946 18.0229 114.115 18.58 115.86 18.58H117.466V23.1746C116.62 23.2293 115.692 23.2577 114.65 23.2577C109.947 23.2577 108.401 21.7819 108.401 17.7728V12.3374H105.867L105.869 7.03382Z"
        fill="currentColor"
      />
      <path
        d="M0.741455 7.21893H3.78261V6.91508C3.78261 2.90293 5.30273 0.898387 10.54 0.898387C11.3106 0.883534 12.0814 0.911598 12.8488 0.98243V5.46457H11.3C9.69597 5.46457 9.35383 5.85455 9.35383 6.88269V7.21692H12.8488V11.8945H9.35795V23.1744H3.78261V11.8966H0.741455V7.21893Z"
        fill="currentColor"
      />
      <path
        d="M34.801 18.4129C33.8791 18.9467 33.4028 19.0653 31.5631 19.0653C29.3803 19.0653 28.5414 18.2984 28.2607 16.9979H38.9801C39.1758 11.3792 38.6995 6.84036 31.5631 6.84036C24.3991 6.84036 22.8882 10.7432 22.8882 15.0875C22.8882 19.5444 24.3991 23.4664 31.5631 23.4664C34.3881 23.4664 36.1725 22.9487 38.0613 21.7333L34.801 18.4129ZM31.3961 11.3792C33.6906 11.3792 33.8545 12.459 33.9426 13.7596H28.2064C28.4297 12.2372 29.157 11.3792 31.3961 11.3792Z"
        fill="currentColor"
      />
      <path
        d="M50.0345 23.1807L47.3005 19.3165L44.5667 23.1807H38.3337L44.1683 14.961L38.8695 7.53428L45.169 7.52921L47.3272 10.5608L49.4865 7.53018L55.8556 7.53428L50.4564 14.9245L56.3084 23.1807H50.0345Z"
        fill="currentColor"
      />
      <path
        d="M75.7209 15.1543C75.7209 9.86485 78.171 6.85754 84.478 6.85754C90.7843 6.85754 93.2067 9.86485 93.2067 15.1543C93.2067 20.4438 90.7858 23.4805 84.478 23.4805C78.1703 23.4805 75.7209 20.4478 75.7209 15.1543ZM87.6027 15.3224C87.6027 13.3169 87.0968 11.8695 84.478 11.8695C81.8586 11.8695 81.3549 13.3169 81.3549 15.3224C81.3549 17.2997 81.8668 18.7745 84.4795 18.7745C87.093 18.7745 87.6027 17.2997 87.6027 15.3224Z"
        fill="currentColor"
      />
    </svg>
  );
}
